module.exports = __webpack_public_path__ + "03_long_yellow.28165189.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/03_long_yellow.png
// module id = WRn1
// module chunks = 0